import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getValuationCurrencies } from '@dealstack/frontend/shared/dataExchange/services/valuations.service';

export function useValuationCurrenciesQuery(
	dealId: string | undefined,
	valuationId: string | undefined
) {
	const query = useQuery({
		queryKey: ['valuation-currencies', dealId ?? '', valuationId ?? ''],
		queryFn: () =>
			getValuationCurrencies({ valuationId: valuationId ?? '', dealId: dealId ?? '' }),
		enabled: !!dealId && !!valuationId,
	});

	const currencies = useMemo(
		() => [...(query.data?.payload?.currencies ?? [])].sort((a, b) => a.localeCompare(b)),
		[query.data?.payload?.currencies]
	);

	return {
		currencies,
		refetchCurrencies: query.refetch,
	};
}
